import { ChevronDownIcon } from '@heroicons/react/24/outline';
import type { AccordionProps } from '@mantine/core';
import { Accordion as MantineAccordion } from '@mantine/core';

import styles from './Accordeon.module.css';

export const LBAccordionContainer = ({
  children,
  ...props
}: AccordionProps) => (
  <MantineAccordion
    {...props}
    chevron={<ChevronDownIcon height={24} width={24} />}
    classNames={styles}
  >
    {children}
  </MantineAccordion>
);
